import * as XLSX from "xlsx";
import { saveAs } from 'file-saver'

export function exportExcelFile(items, fileName, headers) {
    if (items && headers) items.unshift(headers);
    const ws = XLSX.utils.json_to_sheet(items, {skipHeader: 1});
    const wb = {Sheets: {'data':ws}, SheetNames: ['data']};
    const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(blob,fileName)
}
